import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=6d632f16&scoped=true&"
import script from "./TemplatesList.vue?vue&type=script&lang=ts&"
export * from "./TemplatesList.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=6d632f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d632f16",
  null
  
)

export default component.exports